// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
let TMPUIKIT____CssGrid__Jsx3 = require("../../../temporaryUIKit/TMPUIKIT___CssGrid/TMPUIKIT____CssGrid__Jsx3.bs.js");
let DisplayNeighborhoodInputRelay = require("../DisplayNeighborhoodInputRelay.bs.js");
let PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
let PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.bs.js");
let PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.bs.js");

let convertFragment = PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, fRef);
}

let DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftGeocodingStatus_decode = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Utils.localDraftGeocodingStatus_decode;

let FormStateFragment_localDraftGeocodingStatus_fromString = PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.Utils.localDraftGeocodingStatus_fromString;

let FormStateFragment = {
  localDraftGeocodingStatus_decode: FormStateFragment_localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: FormStateFragment_localDraftGeocodingStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__Description__DisplayNeighborhood(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let draft = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_draft_graphql.node, convertFragment, props.draft);
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionDisplayNeighborhood_formState_graphql.node, convertFragment$1, props.formState);
  let displayNeighborhoodIsValid = PropertyWizardFormRelay__Validators__Description.DisplayNeighborhood.useIsValid(draft.fragmentRefs, formState.fragmentRefs);
  let displayNeighborhood = PropertyWizardRelayUtils.FormUtils.useFormControl({
    TAG: "DraftProperty",
    _0: (dp, value) => {
      let newrecord = {...dp};
      newrecord.displayNeighborhood = value !== undefined ? ({
          id: value.id,
          label: value.label
        }) : undefined;
      return newrecord;
    }
  }, props.stepHasBeenTouched, draft.draftProperty.displayNeighborhood, displayNeighborhoodIsValid);
  let match$1 = formState.displayNeighborhoods;
  let match$2 = draft.draftProperty.displayNeighborhood;
  let areas;
  let exit = 0;
  if (match$1.length !== 0 || match$2 === undefined) {
    exit = 1;
  } else {
    areas = [{
        id: match$2.id,
        name: match$2.label
      }];
  }
  if (exit === 1) {
    areas = formState.displayNeighborhoods.map(dn => ({
      id: dn.id,
      name: dn.label
    }));
  }
  let helpText;
  let tmp = match.mode;
  helpText = typeof tmp !== "object" || tmp.TAG !== "Rebroadcast" ? "Select what neighborhood you would like to display on your broadcast.\nCan't find your preferred neighborhood? Just leave it blank. This won't have an impact on matching." : "You can edit the display neighborhood if you wish. This is for display only and has no impact on matching.";
  let match$3 = displayNeighborhood.value;
  let match$4 = formState.geocodingStatus;
  let tmp$1;
  if (match$3 !== undefined) {
    tmp$1 = undefined;
  } else {
    switch (match$4) {
      case "NotCalled" :
        tmp$1 = "Missing address. Please check Key Facts...";
        break;
      case "Called" :
        tmp$1 = "Loading display neighborhoods...";
        break;
      case "Valid" :
        tmp$1 = undefined;
        break;
      default:
        tmp$1 = "Error validating the address. Please check Key Facts...";
    }
  }
  let match$5 = displayNeighborhood.value;
  let match$6 = formState.geocodingStatus;
  let tmp$2;
  tmp$2 = match$5 !== undefined ? false : match$6 !== "Valid";
  let match$7 = displayNeighborhood.valid;
  let match$8 = displayNeighborhood.value;
  return JsxRuntime.jsxs(TMPUIKIT____CssGrid__Jsx3.Cell.make, {
    width: 12,
    children: [
      JsxRuntime.jsx(DisplayNeighborhoodInputRelay.make, {
        areas: areas,
        placeholder: tmp$1,
        helpText: helpText,
        isDisabled: tmp$2,
        onChange: value => displayNeighborhood.onChange(value !== undefined ? ({
            id: value.id,
            label: value.name
          }) : undefined),
        status: match$7 !== undefined ? (
            typeof match$7 === "object" ? "error" : "ok"
          ) : undefined,
        value: match$8 !== undefined ? ({
            id: match$8.id,
            name: match$8.label
          }) : undefined
      }),
      JsxRuntime.jsx(Form__Components.FieldError.make, {
        valid: displayNeighborhood.valid
      })
    ]
  });
}

let Components;

let TextInputField;

let Cell;

let Grid;

let Validators;

let FormUtils;

let make = PropertyWizardRelay__Description__DisplayNeighborhood;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Grid = Grid;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.DraftFragment = DraftFragment;
exports.FormStateFragment = FormStateFragment;
exports.make = make;
/* Form__Components Not a pure module */
